<template>
<v-list>
    <v-tooltip v-if="admin" right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path: '/hotels'}">
                <v-list-item-action>
                    <v-icon>business</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.hotels') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.hotels') }}</span>
    </v-tooltip>

    <v-divider v-if="admin" class="my-1"></v-divider>

    <v-tooltip right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path: '/dashboard'}">
                <v-list-item-action>
                    <v-icon>dashboard</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.dashboard') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.dashboard') }}</span>
    </v-tooltip>

    <v-tooltip right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path:hotel.slug?('/' + hotel.slug + '/inventory-pricing'):'/'}">
                <v-list-item-action>
                    <v-icon>event</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.inventory') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.inventory') }}</span>
    </v-tooltip>

    <v-tooltip right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path: hotel.slug?('/' + hotel.slug + '/reservations'):'/'}">
                <v-list-item-action>
                    <v-icon>room_service</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.reservations') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.reservations') }}</span>
    </v-tooltip>

    <v-tooltip right :disabled="!miniVariant" v-show="hotel.id">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path: '/hotel/' + hotel.id }">
                <v-list-item-action>
                    <v-icon>account_balance</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.hotel_details') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.hotel_details') }}</span>
    </v-tooltip>

    <v-tooltip right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path: hotel.slug?('/' + hotel.slug + '/rate-plans'):'/'}">
                <v-list-item-action>
                    <v-icon>loyalty</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.rate_plans') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.rate_plans') }}</span>
    </v-tooltip>

    <!-- <v-tooltip v-show="hotel.context == 'imemento'&&admin" right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path:hotel.slug?('/' + hotel.slug + '/pricing-rooms-meals'):'/'}">
                <v-list-item-action>
                    <v-icon>restaurant</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.price_room_meals') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.price_room_meals') }}</span>
    </v-tooltip> -->

    <v-tooltip right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path: hotel.slug?( '/' + hotel.slug + '/room-types'):'/'}">
                <v-list-item-action>
                    <v-icon>hotel</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.room_types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.room_types') }}</span>
    </v-tooltip>

    <v-tooltip right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path: hotel.slug?('/' + hotel.slug + '/cancellation-policies'):'/'}">
                <v-list-item-action>
                    <v-icon>bookmark_border</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('app.menu.cancellation_policies') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.cancellation_policies') }}</span>
    </v-tooltip>

    <v-tooltip v-show="hotel.context == 'imemento'&&admin" right :disabled="!miniVariant">
        <template v-slot:activator="{ on }">
            <v-list-item v-on="on" active-class="default-class class-active-menu" class="pa-0 mx-3" :to="{path:hotel.slug?('/' + hotel.slug + '/distribution'):'/'}">
                <v-list-item-action>
                    <v-icon>settings_ethernet</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('app.menu.distribution') }}
                    </v-list-item-title>
                    <span class="badge-new">New</span>
                </v-list-item-content>
            </v-list-item>
        </template>
        <span>{{ $t('app.menu.distribution') }}</span>
    </v-tooltip>

</v-list>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    components: {},
    props: {
        miniVariant: Boolean,
        admin: Boolean,
        hotel: [Object, Promise],
    },
    name: 'App',

    data() {
        return {}
    },

    watch: {},

    mounted() {},

    methods: {
        ...mapActions('alert', ['success', 'error']),

    },
}
</script>
<style lang="stylus">
#app
    #app_container
        .im-nav
            &.theme--light
                &.v-navigation-drawer
                    top: 48px !important
                    background-color: rgb(255, 255, 255)
                    box-shadow: 0 0 15px 0 rgba(0,0,0,.05)
                    .v-list__tile
                        height: 45px
                    .v-navigation-drawer__border
                        width: 0.6px
                    &:not(.v-navigation-drawer--floating)
                        .v-navigation-drawer__border
                            background-color: #f4f4f4
                    .v-list-item--link
                        :before
                            background: inherit
                        &:hover
                            .v-list-item__action
                                .v-icon
                                    transform: translateX(5px)
                            .v-list-item__title
                                transform: translateX(5px)
                    .v-list-item__action
                        min-width: 30px
                        margin-left: 5px
                        margin-right: 5px
                    .v-list-item__title
                        font-size: 15px
                        font-weight: 400
                        color: rgb(98, 98, 98)
                    .v-list-item--active
                        background: linear-gradient(to right, #2C6DE9  5%, #5A8DEE 100%) !important
                        border-radius: 5px
                        box-shadow: 0 0 8px 1px #5A8DEE
                        .badge-new
                            display: none
                        .v-list-item__action
                            .v-icon
                                color: white
                        .v-list-item__title
                            font-weight: 400
                            color: white
                        &:hover
                            background: inherit
                            .v-list-item__action
                                .v-icon
                                    transform: translateX(5px);
                            .v-list-item__title
                                transform: translateX(5px)
        .v-toolbar__title
            &:not(:first-child)
                margin-left: 0px
</style>
